(() => {
  'use strict';

  const EVENT_PREFIX = 'hao_chickendinner';
  const EVENT_NAMES = {
    hero_impression: 'hao_chickendinner:hero_impression',
    hero_click: 'hao_chickendinner:hero_click',
  };
  const MOBILE_QUERY = '(max-width: 749px)';

  function secureRandomBit() {
    try {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % 2;
    } catch (error) {
      return Math.random() < 0.5 ? 0 : 1;
    }
  }

  function forcedVariant() {
    const value = new URLSearchParams(window.location.search).get('hao_hero')?.toLowerCase();
    if (value === 'a' || value === 'move') return 'a';
    if (value === 'b' || value === 'essentials') return 'b';
    return null;
  }

  function publish(root, eventName, payload) {
    if (root.dataset.designMode === 'true') return;
    const qualifiedName = EVENT_NAMES[eventName] || `${EVENT_PREFIX}:${eventName}`;

    try {
      window.dispatchEvent(new CustomEvent(qualifiedName, { detail: payload }));
    } catch (error) {
      // Event observation must never block storefront behavior.
    }

    try {
      if (window.Shopify?.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(qualifiedName, payload);
      }
    } catch (error) {
      // Shopify analytics is optional.
    }

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: qualifiedName, ...payload });
      }
    } catch (error) {
      // A missing or incompatible dataLayer is non-fatal.
    }
  }

  function datasetValue(root, variant, viewport, field) {
    const prefix = variant === 'a' ? 'heroA' : 'heroB';
    if (field === 'image') {
      const responsiveKey = `${prefix}${viewport === 'mobile' ? 'Mobile' : 'Desktop'}`;
      return root.dataset[responsiveKey] || root.dataset[`${prefix}Desktop`] || '';
    }
    return root.dataset[`${prefix}${field}`] || '';
  }

  function initialize(root) {
    if (root.dataset.chickendinnerInitialized === 'true') return;
    const image = root.querySelector('[data-cd-hero-image]');
    const link = root.querySelector('[data-cd-hero-link]');
    if (!image || !link) return;

    root.dataset.heroReady = 'true';
    root.dataset.chickendinnerInitialized = 'true';
    const forced = forcedVariant();
    const variant = forced || (secureRandomBit() === 0 ? 'a' : 'b');
    const media = window.matchMedia(MOBILE_QUERY);
    let impressionPublished = false;
    let fallbackApplied = false;

    const payload = () => ({
      design: 'ChickenDinner',
      variant,
      variant_name: datasetValue(root, variant, media.matches ? 'mobile' : 'desktop', 'Name'),
      destination: link.getAttribute('href'),
      viewport: media.matches ? 'mobile' : 'desktop',
      forced: Boolean(forced),
    });

    const publishImpression = () => {
      if (impressionPublished || !image.complete || image.naturalWidth === 0) return;
      impressionPublished = true;
      publish(root, 'hero_impression', payload());
    };

    const markPaintReady = () => {
      root.dataset.heroPaintReady = 'true';
      publishImpression();
    };

    const ensureDecoded = () => {
      if (!image.complete || image.naturalWidth === 0) return;
      if (typeof image.decode === 'function') {
        image.decode().then(markPaintReady).catch(markPaintReady);
      } else {
        markPaintReady();
      }
    };

    const apply = () => {
      const viewport = media.matches ? 'mobile' : 'desktop';
      const source = datasetValue(root, variant, viewport, 'image');
      const destination = datasetValue(root, variant, viewport, 'Link');
      const label = datasetValue(root, variant, viewport, 'Label');

      root.dataset.heroPaintReady = 'false';
      if (source && image.getAttribute('src') !== source) image.setAttribute('src', source);
      image.setAttribute('alt', '');
      link.setAttribute('href', destination || root.dataset.heroALink || '/collections/all');
      link.setAttribute('aria-label', label || 'Shop Health & Outdoors');
      root.dataset.activeVariant = variant;
      root.dataset.activeViewport = viewport;
      ensureDecoded();
    };

    image.addEventListener('load', ensureDecoded);
    image.addEventListener('error', () => {
      if (fallbackApplied) return;
      const fallback = root.dataset.heroADesktop;
      if (fallback && image.getAttribute('src') !== fallback) {
        fallbackApplied = true;
        image.setAttribute('src', fallback);
      }
    });

    link.addEventListener('click', () => publish(root, 'hero_click', payload()));
    if (typeof media.addEventListener === 'function') media.addEventListener('change', apply);
    else if (typeof media.addListener === 'function') media.addListener(apply);
    apply();
  }

  function initializeAll(container = document) {
    container.querySelectorAll('[data-chickendinner-hero]').forEach(initialize);
  }

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
